import React, { PureComponent } from 'react';
import { Async } from 'react-select';
import { number, string, func, array } from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { statistics, slaves } from '../../../services/ApiService';
import { getSlaveId, isMaster } from '../statisticsHelpers';
import { debounce } from '../../../utils/utils';

import { StatisticsSubIdFilterView } from '../index';

const defaultOption = {
  label: '—',
  value: -1,
};

class StatisticsSubIdFilter extends PureComponent {
  static propTypes = {
    subId: number.isRequired,
    selected: array.isRequired,
    onFilterChange: func.isRequired,
    placeholder: string,
    name: string,
    intl: intlShape.isRequired,
    slavesList: array,
  };

  static defaultProps = {
    subId: 1,
    selected: [],
    onFilterChange() {},
    placeholder: 'Select...',
    slavesList: null,
  };

  state = {
    selected: [],
  };

  componentDidMount() {
    this.setState(() => ({ selected: this.props.selected }));
  }

  getOptions = debounce((input, cb) => {
    const { subId, slavesList } = this.props;
    const q = input.trim();
    const params = {};

    if (q.length > 2) {
      params.q = q;
    }
    const master = isMaster();

    if (master && slavesList) {
      // агрегированная статистика мастера: ищем сабы по всем баерам
      Promise.all(
        slavesList.map(({ id: slaveId }) =>
          slaves
            .getSlaveSubAccounts(subId, { ...params, slaveId })
            .then(({ items = [] }) => items)
            .catch(() => []),
        ),
      )
        .then((responses) => {
          const seen = new Set();
          const options = [];
          responses.forEach((items) => {
            items.forEach((item) => {
              if (!seen.has(item.value)) {
                seen.add(item.value);
                options.push(item);
              }
            });
          });
          cb(null, { options: [defaultOption, ...options] });
        })
        .catch((error) => cb(error, null));
      return;
    }

    const req = !master ? statistics.getSubAccounts : slaves.getSlaveSubAccounts;
    if (master) {
      params.slaveId = getSlaveId();
    }

    req(subId, params)
      .then((data) => data.items)
      .then((options) => cb(null, { options: [defaultOption, ...options] }))
      .catch((error) => cb(error, null));
  }, 500);

  handleChange = (selected) => {
    this.setState(() => ({ selected }));
    const { subId } = this.props;
    this.props.onFilterChange({ [`subId${subId}`]: selected });
  };

  renderLoadingPlaceholder = () => {
    const { intl } = this.props;
    return intl.formatMessage({
      id: 'main.loading',
      defaultMessage: 'Loading...',
    });
  };

  render() {
    const { name, subId, placeholder } = this.props;
    const { selected } = this.state;
    const loadingPlaceholder = this.renderLoadingPlaceholder();

    return (
      <StatisticsSubIdFilterView
        name={name}
        subId={subId}
        placeholder={placeholder}
        selected={selected}
        loadingPlaceholder={loadingPlaceholder}
        searchPromptText={'Нет SubID'}
        handleChange={this.handleChange}
        getOptions={this.getOptions}
      />
    );
  }
}

export default injectIntl(StatisticsSubIdFilter);
